import styled from 'styled-components';
import { media } from '../../../../../theme/mixins/responsive';
import HdTag from '../../../../common/hd-tag';
export const SummaryBoxContainer = styled.div `
  padding-inline: ${({ theme }) => theme.spacing.md}px;
  padding-block: ${({ theme }) => theme.spacing.md}px;
`;
export const SummaryBoxesListTitle = styled.h3 `
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: ${({ theme }) => theme.spacing.lg}px;
  margin-right: ${({ theme }) => theme.spacing.lg}px;
  padding-bottom: ${({ theme }) => theme.spacing.sm}px;
  font-size: 1.25em;
  font-weight: 500;

  ${media.tablet `
    justify-content: center;
    gap: 8px;
    margin-top: ${({ theme }) => theme.spacing.md}px;
    margin-left: 0;
    margin-right: 0;
  `}
`;
export const SummaryBoxesList = styled.div `
  display: grid;
  margin-left: ${({ theme }) => theme.spacing.md}px;
  margin-right: ${({ theme }) => theme.spacing.md}px;
  grid-template-columns: repeat(
    ${({ columns = 3 }) => columns},
    minmax(0, 1fr)
  );

  & > * {
    &:not(:last-child) {
      border-right: 1px solid ${({ theme }) => theme.colors.grey_4};
    }

    &:first-child {
      margin-left: 0;
    }
  }

  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};

  ${media.md `
    grid-template-columns: repeat(1, 1fr);
    padding-inline: 0;  
    margin-left: ${({ theme }) => theme.spacing.md}px;
    margin-right: ${({ theme }) => theme.spacing.md}px;
  
    & > * {
      &:not(:last-child) {

        border-right: none;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
      }
    }
  `}
`;
export const GrantProviderTag = styled(HdTag) `
  color: ${({ theme }) => theme.colors.purple_5};

  &:hover {
    color: ${({ theme }) => theme.colors.purple_2};
    cursor: pointer;
  }
`;
